import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthRoutes } from '../features/auth/components/routes';
import { TaskLoading } from '../components/commons';
import { lazyImport } from '../helpers/lazyImport';

const { PublicIncomingView } = lazyImport(
  () => import('../features/incomingView/components/PublicIncomingView'),
  'PublicIncomingView'
);

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  {
    path: '/onboarding/:viewId',
    element: (
      <Suspense fallback={<TaskLoading variant="rectangular" count={1} height={400} />}>
        <PublicIncomingView />
      </Suspense>
    ),
  },
  {
    path: '/view/:viewId',
    element: (
      <Suspense fallback={<TaskLoading variant="rectangular" count={1} height={400} />}>
        <PublicIncomingView />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/auth/login" replace />,
  },
];
